module.exports = __webpack_public_path__ + "static/insurance-hero.260833bb.webp";